import { AutogenLayoutOpportunitySummary } from "./autogen/AutogenLayoutOpportunitySummary";

export class OpportunitySummary extends AutogenLayoutOpportunitySummary {
    private _opportunityId: string;

    onLoad(): void | Promise<void> {
        this.textboxLastCompletedActivity.quickInfoOverrideSearchMethod = async (layout, keyValue) => {
            if (!this.activeRow.isNull(this.textboxLastCompletedActivity.field)) {
                await layout.search({ "id": this.activeRow.get("id"), "type": "O" });
            }
        }
    }

    get opportunityId(): string {
        return this._opportunityId;
    }

    set opportunityId(value: string) {
        this._opportunityId = value;
        this.sourceOpportunitySummary.search({"id": value});
    }
}